<template>
  <div
    v-if="hasAnimation"
    class="card-row_container"
    :class="[{ 'card-row_empty': !cards }]"
  >
    <div
      class="card-row"
      data-tst="card_row"
    >
      <transition-group
        tag="div"
        name="anim-card-row"
        class="card-row_cards"
      >
        <PokerCard
          v-for="(card, cIdx) in cardsArr"
          :key="`${card}_${cIdx}`"
          :hasAnimation="true"
          :card="card"
          :size="size"
          class="anim-card-row_card card-row_card"
          :style="cardStyle || ''"
          :cardVisual="cardVisual"
          :class="[customAnimation, cardClass || '']"
        ></PokerCard>
      </transition-group>
    </div>
  </div>
  <div
    v-else
    class="card-row"
    :class="{ 'card-row_empty': !cards }"
  >
    <PokerCard
      v-for="(card, cIdx) in cardsArr"
      :key="`${card}_${cIdx}`"
      :card="card"
      :cardVisual="cardVisual"
      :size="size"
      class="card-row_card"
      :style="cardStyle || ''"
      :class="cardClass || ''"
    ></PokerCard>
  </div>
</template>

<script>
import PokerCard from '@/components/Poker/PokerCard/PokerCard'
import { getCardsFromStr } from '@/helpers/cards'

export default {
  name: 'CardRow',
  components: {
    PokerCard,
  },
  props: {
    hasAnimation: { type: Boolean, default: true },
    customAnimation: { default: () => '' },
    cardStyle: String,
    size: { default: () => 'small' },
    cards: String,
    cardClass: String,
    hasSounds: Boolean,
  },

  data() {
    return {
      l_cardsVisible: '',
    }
  },
  methods: {
    setCards() {
      if (this.l_cardsVisible !== this.cards) {
        this.playSounds()
        this.l_cardsVisible = this.cards
      }
    },
    playSounds() {
      if (!this.hasSounds) return
      let diff = (this.cards.length - this.l_cardsVisible.length) / 2
      if (diff > 0) {
        this.$store.dispatch('sounds_play', 'sound_deal_card')
      }
    },
  },
  computed: {
    cardsArr() {
      return getCardsFromStr(this.l_cardsVisible)
    },
    cardVisual() {
      const { cardTheme, cardBack } = this.$store.getters.mergedUserSettings
      return {
        cardTheme,
        cardBack,
      }
    },
  },
  watch: {
    cards: {
      immediate: true,
      handler: 'setCards',
    },
  },
}
</script>
<style lang="scss" scoped>
.card-row_container {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;

  --card-row-min-width: 2.125em;
  --card-enter-x: 0;
  --card-leave-x: 0;
  --card-enter-y: 0;
  --card-leave-y: 0;
}
.card-row_btn {
  --padding: 0.5em;
  --clr-back: rgba(255, 255, 255, 0.05);
  --clr-back-hover: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  padding: var(--padding);
  border-radius: 4px;
  background: var(--clr-back);
  transition: 0.22s;
  &:hover {
    --clr-back: var(--clr-back-hover);
  }
  &.card-row_empty {
    --clr-back: transparent;
  }
}

.card-row {
  --position: relative;
  position: var(--position);
  display: flex;
  align-self: flex-start;
  &_cards {
    display: flex;
    align-items: center;
  }
  &_empty {
    --card-row-min-width: 0;
  }
}

.anim-card-row_card {
  transition: all 0.22s;
}
.anim-card-row-enter-from {
  opacity: 0;
  width: 0px;
}
.anim-card-row-leave-to {
  opacity: 0;
  width: 0px;
}
</style>
